export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '免费平台',
    slug: 'free-platforms',
    description: '精选免费在线观影平台，无需付费即可畅享海量影视资源，适合预算有限的影迷朋友。',
    icon: 'ri-vip-diamond-line',
    count: 8,
  },
  {
    id: 'cat-2',
    name: '付费平台',
    slug: 'paid-platforms',
    description: '高品质付费观影平台测评，涵盖国内外主流视频平台，提供最佳观影体验推荐。',
    icon: 'ri-vip-crown-line',
    count: 6,
  },
  {
    id: 'cat-3',
    name: '高清影视',
    slug: 'hd-movies',
    description: '专注高清画质的观影平台推荐，4K、HDR、杜比全景声等顶级视听体验一网打尽。',
    icon: 'ri-4k-line',
    count: 7,
  },
  {
    id: 'cat-4',
    name: '综艺娱乐',
    slug: 'variety-shows',
    description: '综艺节目、脱口秀、真人秀等娱乐内容一站式观看平台测评与推荐。',
    icon: 'ri-tv-2-line',
    count: 5,
  },
  {
    id: 'cat-5',
    name: '纪录片频道',
    slug: 'documentary',
    description: '自然科学、历史人文、社会纪实等优质纪录片观看平台推荐，满足求知欲与探索心。',
    icon: 'ri-film-line',
    count: 4,
  },
  {
    id: 'cat-6',
    name: '动漫番剧',
    slug: 'anime',
    description: '日漫、国漫、欧美动画等二次元内容观看平台大盘点，动漫爱好者必看指南。',
    icon: 'ri-ghost-line',
    count: 6,
  },
  {
    id: 'cat-7',
    name: '海外平台',
    slug: 'overseas',
    description: 'Netflix、Disney+、HBO Max等国际流媒体平台详细测评与国内访问指南。',
    icon: 'ri-global-line',
    count: 5,
  },
  {
    id: 'cat-8',
    name: '安全指南',
    slug: 'safety-guide',
    description: '在线观影安全须知、VPN使用指南、隐私保护建议，助你安心看片不踩坑。',
    icon: 'ri-shield-check-line',
    count: 4,
  },
];